<div class="modal-bg">
    <img [src]="'assets/img/intern/icons/status/'+ms.status.status+'.svg'" [alt]="ms.status.status" class="icon xl" [class.spin]="ms.status.status==='loading'">
    <p class="title"><small>{{ ms.status.status | Esp }}</small></p>
    <p [innerHtml]="ms.status.msg"></p>

    <button *ngIf="ms.status.status!=='no-log' && ms.status.status!=='loading'" (click)="auth()" class="btn-red sm mt-1">Ok</button>
    <button *ngIf="ms.status.status==='no-log'" (click)="auth('register')" class="btn-red sm mt-1 mr-05">Registrarse</button>
    <button *ngIf="ms.status.status==='no-log'" (click)="auth('login')" class="btn-red sm mt-1 ml-05">Login</button>
</div>